<template>
  <div>
    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.vendorInfo') }}</h2>
      <div class="info-group">
        <div class="info-left">
          <div class="info-item">
            <label>{{ $t('crm.vendorId') }}</label>
            <div class="value">{{ detail.vendorId || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.vendorStoreStatus') }}</label>
            <div class="value">{{ detail.status || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.vendorStartDate') }}</label>
            <div class="value">{{ detail.createAt }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.vendorInfoLastUpdateTime') }}</label>
            <div class="value">{{ detail.updatedAt }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.vendorType') }}</label>
            <div class="value">{{ detail.vendorType || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.vendorCurrency') }}</label>
            <div class="value">{{ detail.originalPriceUnit || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.vendorRegion') }}</label>
            <div class="value">{{ detail.businessRegionName || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.vendorGeography') }}</label>
            <div class="value">{{ detail.addressCountryName || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.vendorLicenceLocation') }}</label>
            <div class="value">{{ detail.businessLicenseLocation || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.parentCompanyName') }}({{ $t('crm.businessEntityName') }})</label>
            <div class="value">{{ detail.groupName || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.parentBranchStore') }}</label>
            <div class="value">
              <span v-if="detail.subVendorType === 1">{{ $t('crm.branchStore') }}({{ $t('crm.parentStore') }}: {{ detail.subVendorName }})</span>
              <span v-if="detail.subVendorType === 2">{{ $t('crm.parentStore') }}</span>
              <span v-if="detail.subVendorType === 3">{{ $t('common.no') }}</span>
            </div>
          </div>
          <div class="info-item" v-if="detail.vendorType == '新批发业务'">
            <label>货单类型</label>
            <div class="value">{{ detail.wholesaleType == 1 ? "现货货单" : detail.wholesaleType == 4 ? "品牌补货 " : detail.wholesaleType == 5 ? "期货预售" : "-" }}</div>
          </div>
        </div>
        <div class="info-right">
          <div class="info-item">
            <label>{{ $t('crm.vendorName') }}</label>
            <div class="value">
              <template v-if="showVendorName">
                <p>{{ detail.vendorName || '-' }} / {{ detail.vendorNameAlias || '-' }}</p>
              </template>
              <template v-else>{{ detail.vendorNameAlias || '-' }}</template>
            </div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.imRepresentative') }}</label>
            <div class="value">{{ detail.boutiqueBd || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.imAssistantRepresentative') }}</label>
            <div class="value">{{ detail.boutiqueAssistant || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.pricingConnectivityMethod') }}</label>
            <div class="value">{{ detail.supplyPriceMethod || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.productConnectivityMethod') }}</label>
            <div class="value">{{ detail.productSourceType || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.stockConnectivityMethod') }}</label>
            <div class="value">{{ detail.stockType || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.contractOrSLASigned') }}</label>
            <div class="value">{{ detail.isSignSla || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.operationType') }}</label>
            <div class="value">{{ detail.operationType || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.vendorsShippingCountry') }}</label>
            <div class="value">{{ detail.shippingCountryName || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.preSaleAvailablity') }}</label>
            <div class="value">{{ detail.isPreSale || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.vat') }}</label>
            <div class="value">{{ detail.taxRate || '-' }}</div>
          </div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.vendorEvaluation') }}</h2>
      <div class="info-group">
        <div class="info-left">
          <div class="info-item">
            <label>{{ $t('crm.vendorsPartnership') }}</label>
            <div class="value">{{ detail.imDefinition || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.mpSalesSatisfaction') }}</label>
            <div class="value">{{ detail.mpSalesSatisfaction || '-' }}</div>
          </div>
        </div>
        <div class="info-right">
          <div class="info-item">
            <label>{{ $t('crm.salesSatisfaction') }}</label>
            <div class="value">{{ detail.wholesaleSalesSatisfaction || '-' }}</div>
          </div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.techInfo') }}</h2>
      <div class="info-group">
        <div class="info-left">
          <div class="info-item">
            <label>{{ $t('crm.stockValidPeriod') }}</label>
            <div class="value">{{ detail.stockExpiry || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.systemName') }}</label>
            <div class="value">{{ detail.systemName || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.personalSellerIMID') }}</label>
            <div class="value">{{ detail.appUserId || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.saleArea') }}</label>
            <div class="value">{{ detail.saleArea || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.orderNotifyEmail') }}</label>
            <div class="value">{{ detail.orderNotificationUrl || '-' }}</div>
          </div>
        </div>
        <div class="info-right">
          <div class="info-item">
            <label>{{ $t('crm.exportfields') }}</label>
            <div class="value">{{ detail.exportFields || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.skuCodeAskeyCode') }}</label>
            <div class="value">{{ detail.skuCodeUnique || '-' }}</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.switchOfFullClared') }}</label>
            <div class="value">
              <span v-if="detail.fullProductIsClear">{{ $t('crm.fullGoods') }}</span>
              <span v-if="detail.fullProductIsClear && detail.fullStockIsClear">、</span>
              <span v-if="detail.fullStockIsClear">{{ $t('crm.fullStock') }}</span>
            </div>
          </div>
          <div class="info-item">
            <label class="placeholder">.</label>
            <div class="value placeholder">.</div>
          </div>
          <div class="info-item">
            <label>{{ $t('crm.orderNotifyStatus') }}</label>
            <div class="value">{{ detail.orderNotificationStatus || '-' }}</div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getVendorDetail } from '../api';

export default {
  data() {
    return {
      detail: {},
    };
  },
  computed: mapState({
    // 查看买手店名称
    showVendorName: (state) => state.app.menuMap['商家CRM-hide-查看买手店名称'],
  }),
  methods:{
    getDeliveryTime(deliveryTime){
       let deliveryList = deliveryTime.map(item=>{
         let num = Number(item.trim())-1
         return this.$t(`common.week${num}`)
       })
       return deliveryList.join(',')
    }
  },
  mounted() {
    getVendorDetail({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        // console.error(res.data.data,'dddd')
        this.detail = res.data.data;
        this.detail.deliveryTime = this.getDeliveryTime(this.detail.deliveryTime)
      }
    })
  },
}
</script>

<style lang="less" scoped>
.box-card {
  margin-bottom: 20px;
}
.info-group {
  display: flex;

  .info-left,
  .info-right {
    flex: 1;
  }
}
.info-item {
  display: flex;
  line-height: 20px;

  .placeholder{
    font-size: 0;
  }
  label {
    flex: 0 0 auto;
    width: 200px;
    padding: 10px;
    background-color: #f9f9f9;
    border-top: 1px solid #EBEEF5;
    border-left: 1px solid #EBEEF5;
  }
  .value {
    flex: 1;
    padding: 10px;
    border-top: 1px solid #EBEEF5;
    border-left: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
  }
  &:last-child {
    label {
      border-bottom: 1px solid #EBEEF5;
    }
    .value {
      border-bottom: 1px solid #EBEEF5;
    }
  }
}
</style>
